/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum DepositTypes {
  CommercialChecking = "Commercial Checking",
  PrivateChecking = "Private Checking"
}
